export var faceExpressionLabels = {
    neutral: 0,
    happy: 1,
    sad: 2,
    angry: 3,
    fearful: 4,
    disgusted: 5,
    surprised: 6
};
//# sourceMappingURL=types.js.map